import type { Icons24, Icons32 } from "$assets/icons.ts";

export type ToolInfo = {
    id: string;
    type: string;
    name: string;
    description: string;
    icon: Icons32;
    options: Record<string, ToolProperty>;
};

export type ToolProperty = {
    icon: Icons24;
    iconOff?: Icons24;
    name: string;
    unit?: string;
};

const commonProperties = {
    size: { icon: "tool-option-size-24", name: "Size", unit: "px" },
    snap: { icon: "tool-option-snap-24", name: "Snap" },
    tolerance: { icon: "missing-24", name: "Tolerance" },
    all_layers: {
        icon: "tool-option-all-layers-on-24",
        iconOff: "tool-option-all-layers-off-24",
        name: "All layers",
    },
    diagonal: {
        icon: "tool-option-diagonal-on-24",
        iconOff: "tool-option-diagonal-off-24",
        name: "Diagonal",
    },
} satisfies Record<string, ToolProperty>;

const allTools = [
    {
        type: "pointer",
        id: "pencil",
        icon: "tool-pencil",
        name: "Pencil",
        description: "铅笔",
        options: {
            size: commonProperties.size,
            snap: commonProperties.snap,
        },
    },
    {
        type: "pointer",
        id: "eraser",
        icon: "tool-eraser",
        name: "Eraser",
        description: "橡皮擦",
        options: {
            size: commonProperties.size,
            snap: commonProperties.snap,
        },
    },
    {
        type: "pointer",
        id: "picker",
        icon: "tool-eyedrop",
        name: "Color picker",
        description: "选色器",
        options: {},
    },
    {
        type: "pointer",
        id: "move",
        icon: "tool-move",
        name: "Move",
        description: "移动",
        options: {},
    },
    {
        type: "pointer",
        id: "fill",
        icon: "tool-bucket",
        name: "Fill",
        description: "填充",
        options: {
            all_layers: commonProperties.all_layers,
            contiguous: {
                icon: "tool-option-contiguous-on-24",
                iconOff: "tool-option-contiguous-off-24",
                name: "Contiguous",
            },
            diagonal: commonProperties.diagonal,
            tolerance: commonProperties.tolerance,
        },
    },
    {
        type: "multi-click",
        id: "line",
        icon: "shape-line",
        name: "Line",
        description: "直线",
        options: {},
    },
    {
        type: "multi-click",
        id: "ellipse",
        icon: "shape-circle",
        name: "Ellipse",
        description: "圆形",
        options: {
            fill: {
                icon: "tool-option-fill-24",
                iconOff: "tool-option-no-fill-24",
                name: "Fill",
            },
        },
    },
    {
        type: "multi-click",
        id: "rectangle",
        icon: "shape-rectangle",
        name: "Rectangle",
        description: "矩形",
        options: {
            fill: {
                icon: "tool-option-fill-24",
                iconOff: "tool-option-no-fill-24",
                name: "Fill",
            },
        },
    },
    {
        type: "multi-click",
        id: "box-select",
        icon: "box-select",
        name: "Box select",
        description: "框选",
        options: {},
    },
    {
        type: "pointer",
        id: "wand-select",
        icon: "wand-select",
        name: "Wand select",
        description: "魔棒选择",
        options: {
            all_layers: commonProperties.all_layers,
            contiguous: {
                icon: "tool-option-contiguous-on-24",
                iconOff: "tool-option-contiguous-off-24",
                name: "Contiguous",
            },
            diagonal: commonProperties.diagonal,
            tolerance: commonProperties.tolerance,
        },
    },
    {
        type: "pointer",
        id: "lasso-select",
        icon: "lasso-select",
        name: "Lasso select",
        description: "套索选择",
        options: {},
    },
    {
        type: "multi-click",
        id: "gradient",
        icon: "missing-32",
        name: "Gradient",
        description: "渐变",
        options: {},
    },
] satisfies ToolInfo[];
export type Tool = (typeof allTools)[number];
export type ToolType = Tool["type"];
export type ToolId = Tool["id"];
export default allTools;
